import $ from 'jquery';
import React from 'react';
import { userService } from '../../_services';

class FindUser extends React.Component {
    constructor(props) {
        super(props);
        var _roletype = '', _rolename = '';
        try {
            var userdata = JSON.parse(localStorage.getItem('user'));
            if (userdata.userrole == "Distributor" && userdata.wholesaler == "Avenel") {
                _roletype = "avdistributor";
                _rolename = userdata.email;
            }
            else if (userdata.userrole == "Distributor" && userdata.wholesaler != "Avenel") {
                _roletype = "distributor";
                _rolename = userdata.paramsname;
            }
            else {
                _roletype = userdata.userrole;
                _rolename = userdata.paramsname;
            }
        }
        catch (error) { }
        this.state = {
            userdata: JSON.parse(localStorage.getItem('user')),
            error: '',
            loader: false,
            SearchDispay: [],
            roletype: _roletype,
            rolename: _rolename,
            conditionalLoader: false,
            disabled: true
        };
    }
    componentDidMount() {
        $("#myInput").focus(function () {
            $('.searchSection').addClass('active');
        });
        $("#myInput").focusout(function () {
            $('.searchSection').removeClass('active');
        });
        setTimeout(() => {
            $('.popup').addClass('mfp-ready');
            $('.popup').addClass('mfp-bg');
            $('.popup').addClass('mfp-with-anim');
        }, 5);
    }
    HandleSearchKeyUp = e => {
        try {
            if ($('#myInput').val().length > 0) {
                this.setState({ disabled: false });
            } else if ($('#myInput').val().length == 0) {
                this.setState({ disabled: true });
                $('#myInputautocomplete-list').css('display', 'none');
            }
        } catch (error) { }
    }
    searchOnButtonClick = e => {
        try {
            if ($('#myInput').val().length >= 0) {
                this.setState({ conditionalLoader: true, disabled: true });
                this.GetSearchDataList($('#myInput').val());
            }
            else {
                this.setState({ SearchDispay: null, error: 'Input field required' });
            }
        } catch (error) { }
    }
    GetSearchDataList(stext) {
        try {
            if (stext.length > 0 && stext.toLowerCase() == 'rxhacker') stext = 'Patient Rx Discount'
            $('#myInputautocomplete-list').css('display', 'block');
            userService.Admin_Any_Search(stext).then(
                apidata => {
                    try {
                        if (apidata.length > 0) {
                            var headingText = apidata.map(item => item.vHeading).filter((value, index, self) => self.indexOf(value) === index);
                            let mainData = [];
                            headingText.forEach((x, i) => {
                                let filterName = [];
                                var valueText = apidata.filter(a => a.vHeading == x);
                                valueText.forEach((y, j) => {
                                    filterName.push(y.vName)
                                });
                                mainData.push({ vHeading: x, vName: filterName })
                            });
                            this.setState({ SearchDispay: mainData, error: '', conditionalLoader: false, disabled: false });
                        }
                        else {
                            this.setState({ SearchDispay: '', error: 'No result found', conditionalLoader: false, disabled: false });
                        }
                    }
                    catch (error) {
                        this.setState({ SearchDispay: '', error: 'Opps!, Something went wrong. Try Again.', conditionalLoader: false, disabled: false });
                    }
                }
            );
        }
        catch (error) {
            this.setState({ SearchDispay: '', error: 'Opps!, Something went wrong. Try Again.', conditionalLoader: false, disabled: false });
        }
    }
    render() {
        const { error, loader, conditionalLoader, disabled } = this.state
        return (
            <div>
                <div className='popup mfp-zoom-in manage-scroll manage-distributor-design admin-group-number find-user'>
                    <div className='popup_inner'>
                        <h1>{this.props.text}<button onClick={this.props.closeFindUser}>X</button></h1>
                        {
                            loader ? (<div className="theme-loader"></div>) : null
                        }
                        <div className="searchSection populate active">
                            <form autoComplete="off" onSubmit={e => { e.preventDefault() }}>
                                <div className="autocomplete">
                                    <input id="myInput" type="text" name="myCountry" placeholder="Search" className="form-control searchFilter" onKeyUp={this.HandleSearchKeyUp} />
                                    <div className="loader-container">
                                        <button className={conditionalLoader ? "signInButton btn animated-btn" : "signInButton btn"} disabled={disabled} onClick={this.searchOnButtonClick}>Search</button>
                                        {
                                            conditionalLoader ? <div className="theme-loader search"></div> : null
                                        }
                                    </div>
                                    <div className="clear"></div>
                                    <div className="broke-section">
                                        {
                                            this.state.SearchDispay != null ? this.state.SearchDispay[0] ?
                                                this.state.SearchDispay.map((item, index) => {
                                                    return (<div><h2>{item.vHeading}</h2>
                                                        {
                                                            item.vName.map((e) => {
                                                                try {
                                                                    return <span>{e.replace('Patient Rx Discount', 'RxHacker')}</span>
                                                                }
                                                                catch(err) {
                                                                    return <span>{e}</span>
                                                                }
                                                            })
                                                        }
                                                    </div>)
                                                })
                                                : null : null
                                        }
                                    </div>
                                </div>
                                {error &&
                                    <div className={'alert alert-danger delete'}>{error}</div>
                                }
                            </form>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}
export default FindUser;